/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ReportAIScanRequestBody,
  ReportAIScanRequestBody$Outbound,
  ReportAIScanRequestBody$outboundSchema,
} from "../components/reportaiscanrequestbody.js";

export type ReportAgentAIScanSecurity = {
  apikeyHeaderGramKey?: string | undefined;
};

export type ReportAgentAIScanRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Email of the enrolled user, sent in the Gram-User-Email header. Authoritative when authenticating with an org-scoped agent install key (the MDM zero-touch path); ignored for a per-user key, whose owner is the enrolled user.
   */
  gramUserEmail?: string | undefined;
  /**
   * Hardware serial number of the machine that was scanned, when the agent can read it.
   */
  gramDeviceSerial?: string | undefined;
  /**
   * Hostname of the machine that was scanned, when the agent can read it.
   */
  gramDeviceHostname?: string | undefined;
  reportAIScanRequestBody: ReportAIScanRequestBody;
};

/** @internal */
export type ReportAgentAIScanSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const ReportAgentAIScanSecurity$outboundSchema: z.ZodMiniType<
  ReportAgentAIScanSecurity$Outbound,
  ReportAgentAIScanSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
    });
  }),
);

export function reportAgentAIScanSecurityToJSON(
  reportAgentAIScanSecurity: ReportAgentAIScanSecurity,
): string {
  return JSON.stringify(
    ReportAgentAIScanSecurity$outboundSchema.parse(reportAgentAIScanSecurity),
  );
}

/** @internal */
export type ReportAgentAIScanRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-User-Email"?: string | undefined;
  "Gram-Device-Serial"?: string | undefined;
  "Gram-Device-Hostname"?: string | undefined;
  ReportAIScanRequestBody: ReportAIScanRequestBody$Outbound;
};

/** @internal */
export const ReportAgentAIScanRequest$outboundSchema: z.ZodMiniType<
  ReportAgentAIScanRequest$Outbound,
  ReportAgentAIScanRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramUserEmail: z.optional(z.string()),
    gramDeviceSerial: z.optional(z.string()),
    gramDeviceHostname: z.optional(z.string()),
    reportAIScanRequestBody: ReportAIScanRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramUserEmail: "Gram-User-Email",
      gramDeviceSerial: "Gram-Device-Serial",
      gramDeviceHostname: "Gram-Device-Hostname",
      reportAIScanRequestBody: "ReportAIScanRequestBody",
    });
  }),
);

export function reportAgentAIScanRequestToJSON(
  reportAgentAIScanRequest: ReportAgentAIScanRequest,
): string {
  return JSON.stringify(
    ReportAgentAIScanRequest$outboundSchema.parse(reportAgentAIScanRequest),
  );
}
